
import React, { useState, useRef, useEffect,useContext,useMemo} from "react";
import { ColumnStyle } from "../theme/ComponentTheme";
import { RenderTextWithTitle,renderTextWithTitleAndChildComponent, detailTextStyle, } from "./TextWithHeader";
import { RBContext } from "../components/RBContext";
import { defaultAllowOffersIcon } from "../components/RBShiftRelatedIcons";
import { Font,Colors, FontSize, Spacing, FontWeight } from "../theme/Theme";
import { makeStyles } from "@material-ui/core";
import moment from "moment-timezone";
import { AuthService } from "../api/AuthService";
import { ShiftService } from "../api/ShiftService";
import { LoadingIndicator } from "./LoadingIndicator";
import { RouteComponentProps } from "react-router";
import { findApplicantUserRequest } from "../util/ShiftToRequest";
import * as mtz from "moment-timezone";

const useStyles = makeStyles({
   
    sectionHeader: {
      fontSize: Font.largest, fontWeight:"bold"
      //  backgroundColor: "red",
    }
  });
  interface ApplicantRequestProp  {
    applicant?: any;
    shiftId?: string;
    shiftData?: any;
    page?:string;
  }
  export const ApplicantRequest = ({ applicant, shiftId,shiftData, page }: ApplicantRequestProp) => {
    const [userRequest, setUserRequest] = useState<any>(null);
    const { secondaryColor } = useContext(RBContext);
    const [statData, setStatData] = useState<any>(null);
    // const [comment,SetComment] = useState<string>("The starting and ending pages are chosen either by the players themselves or by an impartial overseer (referee). When playing for the fewest clicks, a precise tally must be kept of each click made by a player, with all selections accounted for. The player with the fewest clicks wins. The browser's history can be used to verify the number of articles visited.");
     useEffect(() => {
    if (applicant && shiftId) {
      const matchedRequest = findApplicantUserRequest(applicant, shiftId);
      
      setUserRequest(matchedRequest);
    }
  }, [applicant, shiftId]);

  const isRequested =
    !!(
      userRequest &&
      (userRequest.isWageRequested||
        userRequest.isStartTimeRequested||
        userRequest.isEndTimeRequested)
    );
  
  const comment = userRequest?.explanation || "N/A"; 
  const tz =  shiftData?.shiftTimeZone || "UTC";
  let hours: number | null = null;
  // determine start/end candidates (request first, then official, then start)
  const startCandidate =
    userRequest?.requestedStartTime ?? shiftData?.officialStartTime ?? shiftData?.startTime ?? null;
  const endCandidate =
    userRequest?.requestedEndTime ?? shiftData?.officialEndTime ?? shiftData?.endTime ?? null;

  if (startCandidate && endCandidate) {
    const start = mtz.tz(startCandidate, tz);
    const end = mtz.tz(endCandidate, tz);
    const diffMinutes = end.diff(start, "minutes");
    hours = diffMinutes > 0 ? diffMinutes / 60 : 0;
    console.log("hours ", hours);
  }

  // requestedWage is in cents — convert to dollars per hour
  const hourlyRate = userRequest?.requestedWage ? userRequest.requestedWage / 100 : null;
  const estimatedTotalWage = hours !== null && hourlyRate !== null ? hourlyRate * hours : null;

  // Duration display between the (requested) start and end candidates
  const durationDisplay = startCandidate && endCandidate
    ? ShiftService.getDurationDisplay(startCandidate, endCandidate, tz)
    : "N/A";
 

   // color mapping for flags (orange when requested, green otherwise)
  const orange = "#F57C00";
  const green = "rgb(52, 175, 71)";
  const neutral = Colors.defaultGrey || "inherit";

  const wageColor = userRequest ? (userRequest.isWageRequested ? orange : green) : neutral;
 const startColor = userRequest ? (userRequest.isStartTimeRequested ? orange : green) : neutral;
 const endColor = userRequest ? (userRequest.isEndTimeRequested ? orange : green) : neutral;
   const durationColor = userRequest
    ? (userRequest.isStartTimeRequested || userRequest.isEndTimeRequested ? orange : green)
    : neutral;



// ---------- RB commission helpers (adapted from reference) ----------
   const renderRbCommission = (
    hourlyRate: number | null,
    hours: number | null,
    shiftParam?: any | null
  ): string => {
    const shift = shiftParam ?? shiftData;
    if (!shift) return "N/A";

    // const allowOffers = shift?.allowOffers;
    // if (!allowOffers) return "N/A";

    const networkPaid = shift?.pharmacy?.networkPaid ?? shift?.networkPaid;
    if (!networkPaid) return "N/A";

    const requestedWageCents =
      typeof hourlyRate === "number" ? Math.round(hourlyRate * 100) : shift?.requestedWage ?? 0;

    const shiftCopy = { ...(shift || {}), requestedWage: requestedWageCents };

    const feeRaw =
      shiftCopy.actualCommission != null
        ? ShiftService.getPlacementFee(shiftCopy, {
            minutesWorked: hours != null ? hours * 60 : undefined,
            requestedWage: requestedWageCents,
          })
        : ShiftService.getCommission(shiftCopy, requestedWageCents) / 100; // getCommission returns cents

    if (!Number.isFinite(feeRaw)) return "$0.00";
    return `$${Number(feeRaw).toFixed(2)}`;
  };



  const getCommission = (shift: any, requestedWage: number | undefined) => {
    const wage = requestedWage ?? shift.requestedWage ?? 0; // cents
    let rbCommission = 0;
    if (shift.pharmacy?.networkPaid) {
      rbCommission = wage * (shift.pharmacy.commissionPercentage / 100); // cents
    }
    return Math.floor(rbCommission); // cents
  };
  
  // useEffect(() =>{

    //     loadStatsDetails()
    // },[])
    // const loadStatsDetails = async () => {
    //     let statDetails = await AuthService.fetchWorkerStats(props.account.id);
    //     setStatData(statDetails)
    // }
    console.log("userRequest at ApplicantRequest ", userRequest);
    console.log("applicant at ApplicantRequest ", applicant);
    console.log("shiftId at ApplicantRequest ",shiftId);
    const classes = useStyles();
    return (
        <>
            <div style={ColumnStyle}>
                <div
                    className={classes.sectionHeader}
                    color="primary"
                    style={{
                        display: "flex",
                        // flex: 1,
                        overflowWrap: "anywhere",
                    }}
                >
                    Applicant Request
                </div>
            </div>
            <div style={ColumnStyle}>
              
                 {renderTextWithTitleAndChildComponent(
                   "Start Time",
                   <div style={{ ...detailTextStyle }}>{startCandidate ? <span style={{ color: startColor,fontWeight: "bold" }}>{mtz.tz(startCandidate, tz).format("ddd, MMM Do YYYY h:mm a")}</span> : <span style={{ color: neutral }}>N/A</span>}</div>
                 )}
                   {renderTextWithTitleAndChildComponent(
                   "End Time",
                   <div style={{ ...detailTextStyle }}>{endCandidate ? <span style={{ color: endColor,fontWeight: "bold" }}>{mtz.tz(endCandidate, tz).format("ddd, MMM Do YYYY h:mm a")}</span> : <span style={{ color: neutral }}>N/A</span>}</div>
                 )}
                
                 {/* {RenderTextWithTitle(
                  "Est.Placement fee:",
                  // guard: don't call until shiftData is defined
                  // shiftData ? renderRbCommission(hourlyRate, hours, shiftData) : "N/A",
                  placementFeeDisplay
                )} */}
                
               
            </div>
            <div style={ColumnStyle}>
              {renderTextWithTitleAndChildComponent(
                "Duration",
                <div style={{ ...detailTextStyle }}>{durationDisplay ? <span style={{ color: durationColor, fontWeight: "bold" }}>{durationDisplay}</span> : <span style={{ color: neutral }}>N/A</span>}</div>
              )}

              {renderTextWithTitleAndChildComponent(
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div >{"Hourly Rate"}</div>
                  {shiftData?.allowOffers && defaultAllowOffersIcon(secondaryColor)}
                </div>,
                <div style={{ ...ColumnStyle }}>
                  {hourlyRate !== null ? <span style={{ ...detailTextStyle, color: wageColor, fontWeight: "bold" }}>{`$${hourlyRate.toFixed(2)}`}</span> : <span style={{ color: neutral }}>N/A</span>}
                </div>
              )}
            </div>


            <div style={ColumnStyle}>
              
                {RenderTextWithTitle("Est.Total Wage", estimatedTotalWage !== null
              ? `$${estimatedTotalWage.toFixed(2)}`
              : hours !== null && hourlyRate === null
              ? `${hours.toFixed(2)} hrs`
              : "N/A")}

               {/* {shiftData?.pharmacy?.networkPaid && shiftData.allowOffers ? */}
               {shiftData?.pharmacy?.networkPaid ? 
            <>
           {RenderTextWithTitle(
                 "Est.Placement Fee",
                 // call with explicit shiftData so the helper can compute or return "N/A"
                 renderRbCommission(hourlyRate, hours, shiftData)
               )}
            </>:
            <>
                 {RenderTextWithTitle("", "")}
           </>
          }
                {/* {RenderTextWithTitle("",  '')} */}
                
               
            </div>



         <div style={ColumnStyle}>
                <div
                    style={{
                      height: 2,
                      backgroundColor: Colors.defaultGrey,
                      marginTop: Spacing.medium,
                      marginBottom: Spacing.medium,
                    }}
                  />
            
            
                     {RenderTextWithTitle("Request Comment", comment)}
            
        
                   <div
                    style={{
                      height: 1,
                      backgroundColor: Colors.defaultGrey,
                      marginTop: Spacing.medium,
                      marginBottom: Spacing.medium,
                    }}
                  />

</div>

           
<div style={ColumnStyle}></div>

          
        </>
    );
}